import React, { Component } from 'react';
import PropTypes from 'prop-types';
import localStorage from '../../lib/localstorage';

const STORAGE_KEY = '_gurusSeenMessages';

const closeButtonStyle = {
  position: 'absolute',
  top: '8px',
  right: '16px',
  background: 'none',
  border: 'none',
  fontSize: '20px',
  color: '#9ca3af',
  cursor: 'pointer'
};

const dotStyle = active => ({
  width: '8px',
  height: '8px',
  border: 'none',
  cursor: 'pointer',
  padding: 0,
  borderRadius: '50%',
  backgroundColor: active ? '#4b5563' : '#d1d5db'
});

class CourseMessageBanner extends Component {
  constructor(props) {
    super(props);

    const normalizedMessages = props.messages.map(msg => ({
      ...msg,
      id: String(msg.id)
    }));

    const dismissedIds = CourseMessageBanner.getDismissedIds();
    const remainingMessages = normalizedMessages.filter(
      msg => !dismissedIds.includes(msg.id)
    );

    this.state = {
      dismissedIds,
      remainingMessages,
      selectedIndex: 0
    };

    this.selectMessage = this.selectMessage.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
  }

  static getDismissedIds() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  dismissMessage() {
    const { remainingMessages, dismissedIds, selectedIndex } = this.state;
    const currentMessage = remainingMessages[selectedIndex];

    if (!currentMessage) return;

    const updatedDismissedIds = [...dismissedIds, currentMessage.id];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedDismissedIds));

    const updatedRemainingMessages = remainingMessages.filter(
      msg => !updatedDismissedIds.includes(msg.id)
    );

    this.setState({
      dismissedIds: updatedDismissedIds,
      remainingMessages: updatedRemainingMessages,
      selectedIndex: Math.max(selectedIndex - 1, 0)
    });
  }

  selectMessage(index) {
    const currentMessage = this.state.remainingMessages[index];

    if (currentMessage) {
      this.setState({
        selectedIndex: index
      });
    }
  }

  renderDots() {
    const { remainingMessages, selectedIndex } = this.state;
    if (remainingMessages.length <= 1) return null;

    return (
      <div className="l-flex t-gap-s qa-dots">
        {remainingMessages.map((msg, index) => (
          <button
            type="button"
            key={msg.id}
            onClick={() => this.selectMessage(index)}
            aria-label={`Show message ${index + 1}`}
            style={{
              ...dotStyle(index === selectedIndex)
            }}
          />
        ))}
      </div>
    );
  }

  render() {
    const { remainingMessages, selectedIndex } = this.state;
    const currentMessage = remainingMessages[selectedIndex];
    if (!currentMessage) return null;

    const hasLink = !!currentMessage.moreInfoUrl;

    return (
      <div className="c-card c-card--highlight t-position--relative qa-course-message-banner">
        <button
          type="button"
          onClick={this.dismissMessage}
          style={closeButtonStyle}
          aria-label="Dismiss"
        >
          x
        </button>

        {currentMessage.title && (
          <div className="o-h2 t-text-weight--bold t-margin-small--bottom">
            {currentMessage.title}
          </div>
        )}

        {currentMessage.message && (
          <p className="t-no-margin">{currentMessage.message}</p>
        )}

        {(hasLink || remainingMessages.length > 1) && (
          <div className="l-flex l-flex--split l-flex--center t-margin--top">
            {remainingMessages.length > 1 ? (
              this.renderDots()
            ) : (
              <div style={{ width: '1px' }} />
            )}

            {hasLink && (
              <a
                rel="noopener noreferrer"
                href={currentMessage.moreInfoUrl}
                className="o-button o-button--small o-button--test-color"
                target="_blank"
              >
                {(currentMessage && currentMessage.buttonCaption) ||
                  'Mehr erfahren'}
              </a>
            )}
          </div>
        )}
      </div>
    );
  }
}

CourseMessageBanner.propTypes = {
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string,
      message: PropTypes.string.isRequired,
      moreInfoUrl: PropTypes.string,
      buttonCaption: PropTypes.string
    })
  ).isRequired
};

export default CourseMessageBanner;
